import {compose, createStore, applyMiddleware} from 'redux';
import Thunk from 'redux-thunk';
import reducer from './modules';
import {actions} from './modules';
import Utils from '../common/Utils';

import Router from './Router';

import SearchBox from './search/SearchBox';
import SidebarItem from './sidebar/SidebarItem';
import SidebarSkill from './sidebar/SidebarSkill';
import SelectBox from './sidebar/SelectBox';
import CategoriesItem from './sidebar/CategoriesItem';
import CategoriesSkill from './sidebar/CategoriesSkill';
import Level from "./sidebar/Level";
import ListItem from './list/ListItem';
import ListSkill from './list/ListSkill';
import Pagenation from './list/Pagination';
import Detail from './detail/Detail';
import RecentHistory from './recent/RecentHistory';
import RecentNextPrev from './recent/RecentNextPrev';

class App {
    constructor(_config = {}) {
        const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

        this.store = createStore( reducer, composeEnhancers( applyMiddleware(Thunk) ));
        this.store.dispatch( actions.setConfig(_config) );
        this.router = new Router( this.store );

        let initFn = {
            'item': this.initItem,
            'skill': this.initSkill,
        }[_config.db].bind(this)();

        if ((Utils.getParamByName('skillid') || Utils.getParamByName('itemid'))) {
            this.store.dispatch( actions.setDetailIsshow(true) );
        }
    }

    initItem(){
        new SearchBox( this.store, this.router, '#autoSuggest' );
        new SidebarItem( this.store, this.router, '#gamedictionary' );
        new SelectBox( this.store, this.router, '#gamedictionary .gd-filter-condition .gd-select', 'grades', 'selectGrades', 'grade');
        new CategoriesItem( this.store, this.router, '#gamedictionary' );
        new ListItem( this.store, this.router, '#gamedictionary' );
        new Pagenation( this.store, this.router, '#gamedictionary' );
        new Detail( this.store, this.router, '#gamedictionary' );
        new RecentHistory( this.store, this.router, '#gamedictionary' );
        new RecentNextPrev( this.store, this.router, '#gamedictionary' );
    }

    initSkill(){
        new SearchBox( this.store, this.router, '#autoSuggest' );
        new SidebarSkill( this.store, this.router, '#gamedictionary' );
        new Level( this.store, this.router, '#gamedictionary' );
        new SelectBox( this.store, this.router, '#gamedictionary .gd-filter-condition-types .gd-select', 'types', 'selType', 'type');
        new SelectBox( this.store, this.router, '#gamedictionary .gd-filter-condition-typesoper .gd-select', 'typesOper', 'selTypesOper', 'typesoper');
        new CategoriesSkill( this.store, this.router, '#gamedictionary' );
        new ListSkill( this.store, this.router, '#gamedictionary' );
        new Pagenation( this.store, this.router, '#gamedictionary' );
        new Detail( this.store, this.router, '#gamedictionary' );
        new RecentHistory( this.store, this.router, '#gamedictionary' );
        new RecentNextPrev( this.store, this.router, '#gamedictionary' );
    }
}

Utils.namespace('nc.gamedic.dicL2');
nc.gamedic.dicL2 = App;